import axios from 'axios';
import { API_KEY, SHEETS_API_URL, SPREADSHEET_ID } from '../constants';

/**
 * @param {string} range A1 notation, ej. "Usuarios!B1:C500" o "Inversiones!A1:Z200"
 */
export function fetchSheetRange(range) {
  const encoded = encodeURIComponent(range);
  return axios
    .get(
      `${SHEETS_API_URL}${SPREADSHEET_ID}/values/${encoded}?key=${API_KEY}`
    )
    .then((res) => res.data.values || []);
}
